import React from 'react';
import { NavCarousel } from '../NavCarousel/NavCarousel';
import { NavChip, NavChipProps } from '../NavChip/NavChip';
import { ThumbnailImageCarousel } from '../ThumbnailImageCarousel/ThumbnailImageCarousel';
import { useContentfulCollection } from '../hooks/useContentfulCollection/useContentfulCollection';
import { CollectionTransformer } from '../Contentful/transformers/CollectionTransformer';
import { ContentfulMetafieldCollection } from '@jbhi-fi/apis/src/contentful/types';
import { MetafieldCollectionTransformer } from '../Contentful/transformers/MetafieldCollectionTransformer';
import { ThumbnailImageProps } from '../ThumbnailImage/ThumbnailImage';

export type CollectionHeaderNavProps = {
  metafieldCollection: ContentfulMetafieldCollection;
};

export const CollectionHeaderNav = ({ metafieldCollection }: CollectionHeaderNavProps) => {
  const { collection, isLoading } = useContentfulCollection({ handle: metafieldCollection.handle });
  const isVisualBrowseNav =
    ((collection?.fields?.browseNavVisual || metafieldCollection.browseNavVisual) ?? '').toLowerCase() === 'image';

  if (isVisualBrowseNav) {
    const thumbnails: Array<ThumbnailImageProps> = collection?.fields?.browseNav?.length
      ? CollectionTransformer.toThumbnailImagesProps(collection) || []
      : MetafieldCollectionTransformer.toThumbnailImagesProps(metafieldCollection, { isLoading }) || [];

    if (!thumbnails?.length) return null;
    return <ThumbnailImageCarousel thumbnails={thumbnails} />;
  }

  const chips: Array<NavChipProps> = collection?.fields?.browseNav?.length
    ? CollectionTransformer.toNavChipsProps(collection) || []
    : MetafieldCollectionTransformer.toNavChipsProps(metafieldCollection) || [];

  if (!chips?.length) return null;
  return (
    <NavCarousel title={`Browse ${collection?.fields?.title ?? metafieldCollection?.title ?? ''}:`}>
      {chips.map(({ href, label }, i) => (
        <NavChip href={href} label={label} key={i} />
      ))}
    </NavCarousel>
  );
};
